import VideoControls from '@utils/videoControls';

/**
 * Handles static primary hero functionality without Dynamic Yield integration.
 * Initializes video play/pause controls when present.
 */
export default class StaticPrimaryHero {
  private moduleEl: HTMLElement;

  constructor(context: HTMLElement) {
    this.moduleEl = context;
    this.initVideoControls();
  }

  /**
   * Initializes custom video play/pause controls if the controls element is
   * present and native controls are not in use.
   */
  private initVideoControls(): void {
    const videoControlsEl = this.moduleEl.querySelector<HTMLElement>(
      '.js--video-controls'
    );
    if (videoControlsEl) {
      new VideoControls(videoControlsEl, this.moduleEl);
    }
  }
}
